import React from 'react';
import { Link, useParams } from 'react-router-dom';
import './ProductDetail.css';
import karan1 from './karan/Karan Acoustics Phono A Amplifier.png';
import karan2 from './karan/Karan Acoustics Mono A amplifier.png';
import karan3 from './karan/KARAN ACOUSTICS MASTER COLLECTION POWER B STEREO.png';
import karan4 from './karan/KARAN ACOUSTICS MASTER COLLECTION PRE-AMPLIFIER&PSUA.png';
import karan5 from './karan/KARAN ACOUSTICSMASTER COLLECTION  LINE B PRE-AMPLIFIER.png';
import karan6 from './karan/KARAN ACOUSTICS MASTER COLLECTION PHONO B.png';
import karan7 from './karan/KARAN ACOUSTICS MASTER COLLECTION PHONO B MONO.png';
import kuzma1 from './kuzma/STABI S TURNTABLE.png'
import kuzma2 from './kuzma/STABI R TURNTABLE.png';
import kuzma3 from './kuzma/STABI REFERENCE 2 TURNTABLE.png';
import kuzma4 from './kuzma/STABI M TURNTABLE.png';
import kuzma5 from './kuzma/KUZMA XL DC TURNTABLE.png';
import kuzma6 from './kuzma/KUZMA XL AIR TURNTABLE.png';
import kuzma7 from './kuzma/STOGI S TONEARM.png';
import kuzma8 from './kuzma/STOGI REFERENCE TONEARM.png';
import kuzma9 from './kuzma/STOGI REFERENCE 313 TONEARM.png';
import kuzma10 from './kuzma/4 POINT 9 TONEARM.png';
import kuzma11 from './kuzma/4 POINT TONEARM.png';
import kuzma12 from './kuzma/4 POINT 14 TONEARM.png';
import kuzma13 from './kuzma/SAFIR 9 TONEARM.png';
import kuzma14 from './kuzma/AIRLINE TONEARM.png';
import kuzma15 from './kuzma/KUZMA CAR-20.png';
import kuzma16 from './kuzma/KUZMA CAR-30.png';
import kuzma17 from './kuzma/KUZMA CAR-40.png';
import kuzma18 from './kuzma/KUZMA CAR-50.png';
import kuzma19 from './kuzma/KUZMA CAR-60.png';
import kuzma20 from './kuzma/KUZMA SAFIR 12 TONEARM.jpeg';
// import walkeraudio1 from './walkeraudio/WALKER AUDIO PROSCENIUM BLACK DIAMOND MKII TURNTABLE.png';
// import walkeraudio2 from './walkeraudio/WALKER AUDIO ONLY UPRGADE AVAILABLE.png';
import walkeraudio3 from './walkeraudio/Walker Audio Proscenium Black Diamond MK5 Turntable.png';
import consolidated1 from './consolidated/Consolidated Audio Step-up Transformer.png';
import keith1 from './keith/KEITH MONKS MICRO LIGHT.png';
import keith2 from './keith/KEITH MONKS PRODIGY.png';
import keith3 from './keith/KEITH MONKS REDUX DISCOVERY ONE.png';
import keith4 from './keith/KEITH MONKS REDUX 2 DISCOVERY ONE.png';
// import michell1 from './michell/MICHELL ORBE.png';
// import michell2 from './michell/MICHELL ORBE SE.png';
// import michell3 from './michell/MICHELL GYRODEC.png';
// import michell4 from './michell/MICHELL GYRO SE.png';
import michell5 from './michell/MICHELL TECNODEC.png';
import michell6 from './michell/MICHELL AUDIO REVOLVE TURNTABLE.png';
import michell7 from './michell/MICHELL AUDIO GYRO TURNTABLE.png';
import michell8 from './michell/APOLLO PHONOSTAGE.png';
import michell9 from './michell/MICHELL T2 TONEARM.png';
import michell10 from './michell/MICHELL T8 TONEARM.png';
import michell11 from './michell/MICHELL TECNOARM 2 TONEARM.png';
import michell12 from './michell/CUSIS E - EH - S.png';
import michell13 from './michell/CUSIS M.png';
import sota1 from './sota/SOTA COSMOS ECLIPSE.png';
import sota2 from './sota/SOTA MILLENNIA ECLIPSE.png';
import sota3 from './sota/SOTA SAPHIRE VII.png';
import sota4 from './sota/SOTA NOVA VII.png';
import sota5 from './sota/SOTA QUASAR.png';
import sota6 from './sota/SOTA COMET VI.png';
// import dsa1 from './dsa/DSA PHONO III.png';
// import dsa2 from './dsa/DSA AMP I.png';
// import dsa3 from './dsa/DSA PRE I.png';
// import dsa4 from './dsa/DSA PHONO II.png';
// import dsa5 from './dsa/DSA PHONO-ONE.png';
import kudos1 from './kudos/KUDOS TITAN 808 SPEAKERS.png';
import kudos2 from './kudos/KUDOS TITAN 707 SPEAKERS.png';
import kudos3 from './kudos/KUDOS TITAN 606 SPEAKERS.png';
import kudos4 from './kudos/KUDOS TITAN 505 SPEAKERS.png';
import kudos5 from './kudos/KUDOS KS1 SPEAKER CABLE.png';
import kudos6 from './kudos/KUDOS AUDIO SIGAO DRIVE.png';
import csport1 from './csport/CSPORT MONAURAL POWER AMPLIFIER 212PAM2.png';
import csport2 from './csport/CSPORT STEREO PRE-AMPLIFIER C3PR.png';
import csport3 from './csport/CSPORT STEREO POWER AMPLIFIER GM70PA.png';
import csport4 from './csport/CSPORT PHONO AMPLIFIER C3EQM2.png';
import csport5 from './csport/CSPORT LFT1M2 TURNTABLE.png';
import csport6 from './csport/CSPORT TAT1M2 TURNTABLE.png';
import csport7 from './csport/CSPORT TAT2M2 TURNTABLE.png';
import csport8 from './csport/CSPORT LINEAR ARM AFU1-2.png';
import csport9 from './csport/CSPORT STATIC ELIMINATOR AND DEMAG IME1.png';
import csport10 from './csport/CSPORT ACTIVE CROSSOVER ACN400.png';
import hartvig1 from './hartvig/HARTVIG EVOLUTION TURNTABLE.png';
import hartvig2 from './hartvig/HARTVIG SIGNATURE TURNTABLE.png';
import hartvig3 from './hartvig/HARTVIG TURNTABLE.png';
import triplanar1 from './triplanar/TRIPLANAR ULTIMATE 12 TONEARM.png';
import triplanar2 from './triplanar/TRIPLANAR U2SE TONEARM.png';
import triplanar3 from './triplanar/TRIPLANAR MKVII U2 CLASSIC.png';
// import russellK1 from './russellK/RUSSELL K. RED 50 LOUDSPEAKERS.png';
// import russellK2 from './russellK/RUSSELL K. RED 100 LOUDSPEAKERS.png';
// import russellK3 from './russellK/RUSSELL K. RED 120 LOUDSPEAKERS.png';
// import russellK4 from './russellK/RUSSELL K. RED 120 SE LOUDSPEAKERS.png';
// import russellK5 from './russellK/RUSSELL K. RED 150 LOUDSPEAKERS.png';
// import russellK6 from './russellK/RUSSELL K. RED 150 SE LOUDSPEAKERS.png';
import atmasphere1 from './atmasphere/ATMA-SPHERE S-30 TUBE AMPLIFIER.png';
import atmasphere2 from './atmasphere/ATMA-SPHERE M-60 TUBE AMPLIFIER.png';
import atmasphere3 from './atmasphere/ATMA-SPHERE MA-1 TUBE AMPLIFIER.png';
import atmasphere4 from './atmasphere/ATMA-SPHERE MA-2 TUBE AMPLIFIER.png';
import atmasphere5 from './atmasphere/ATMA-SPHERE MA-3 TUBE AMPLIFIER.png';
import atmasphere6 from './atmasphere/ATMA-SPHERE CLASS D MONOBLOCKS.png';
import atmasphere7 from './atmasphere/ATMA-SPHERE GEM 5 AMPLIFIER.png';
import atmasphere8 from './atmasphere/ATMA-SPHERE UV-1 ULTRAVIOLET PRE AMPLIFIER.png';
import atmasphere9 from './atmasphere/ATMA-SPHERE MP-3 PRE AMLIFIER.png';
import atmasphere10 from './atmasphere/ATMA-SPHERE MP-1 PRE AMPLIFIER.png';
import zestoaudio1 from './zestoaudio/EROS 500.png';
import zestoaudio2 from './zestoaudio/BIA 200.png';
import zestoaudio3 from './zestoaudio/LETO ULTRA II PREAMPLIFIER.png';
import zestoaudio4 from './zestoaudio/ANDROS TESSERA REFRENCE PHONOSTAGE.png';
import zestoaudio5 from './zestoaudio/ANDROS DELUXE II PHONOSTAGE.png';
import zestoaudio6 from './zestoaudio/ANDROS II PHONOSTAGE.png';
import zestoaudio7 from './zestoaudio/ANDROS SPIRIT PHONOSTAGE.png';
import zestoaudio8 from './zestoaudio/ATHENA DAC.png';
import zestoaudio9 from './zestoaudio/ANDROS ALLASSO STEP UP TRANSFORMER.png';
import uberlight1 from './uberlight/UBERLIGHT FRAME LED DESK AUDIO LIGHTING 7100TL WHITE.png';
import uberlight2 from './uberlight/UBERLIGHT FRAME LED DESK AUDIO LIGHTING 7200TL BLACK.png';
import uberlight3 from './uberlight/UBERLIGHT FLEX 3100TL LED TASK LIGHT, USB WITH CLAMP WHITE.png';
import uberlight4 from './uberlight/UBERLIGHT FLEX 3100TL LED TASK LIGHT, USB WITH CLAMP BLACK.png';
import uberlight5 from './uberlight/UBERLIGHT FLEX 4100 TL LED TASK LIGHT, USB WITH BASE WHITE.png';
import uberlight6 from './uberlight/UBERLIGHT FLEX 4100 TL LED TASK LIGHT, USB WITH BASE BLACK.png';
import trennerFriedl1 from './trenner&friedl/TRENNER & FRIEDL WATCH.png';
import trennerFriedl2 from './trenner&friedl/SUN.png';
import trennerFriedl3 from './trenner&friedl/ART.png';
import trennerFriedl4 from './trenner&friedl/PHARAOH.png';
import trennerFriedl5 from './trenner&friedl/RA.png';
import trennerFriedl6 from './trenner&friedl/ISIS.png';
import trennerFriedl7 from './trenner&friedl/TALIESIN.png';
import trennerFriedl8 from './trenner&friedl/DUKE.png';
import trennerFriedl9 from './trenner&friedl/ORINOCO FLOW SPEAKER CABLES.png';
import './responsive.css';



const modelsData = {
  'KARAN ACOUSTICS': {
    'AMPLIFIER': [
    { id: 'karan1', name: 'KARAN ACOUSTICS PHONO A AMPLIFIER', 
      image: karan1
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-phonoa/' 
    },
    { id: 'karan2', name: 'KARAN ACOUSTICS MONO A AMPLIFIER', 
      image: karan2 
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-powera-mono/'
    },
    { id: 'karan3', name: 'KARAN ACOUSTICS MASTER COLLECTION POWER B STEREO', 
      image: karan3
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-powerb-stereo/'   
    },
    { id: 'karan8', name: 'KARAN ACOUSTICS STEREO A AMPLIFIER', 
        image: karan3
      , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-powerb-stereo/'   
    },
    { id: 'karan4', name: 'KARAN ACOUSTICS MASTER COLLECTION PRE-AMPLIFIER & PSU A', 
      image: karan4
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-linea-psua/'   
    },
    { id: 'karan5', name: 'KARAN ACOUSTICS MASTER COLLECTION LINE B PRE-AMPLIFIER', 
      image: karan5
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-lineb/'   
    },
    { id: 'karan6', name: 'KARAN ACOUSTICS MASTER COLLECTION PHONO B', 
      image: karan6
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-phonob/'   
    },
    { id: 'karan7', name: 'KARAN ACOUSTICS MASTER COLLECTION PHONO B MONO', 
      image: karan7
    , link: 'https://www.karanacoustics.com/product/karan-acoustics-master-collection-powerb-mono/'   
    },
  ], 
  },

  'KUZMA': {
  'TURNTABLE': [ 
    { id: 'kuzma6', name: 'KUZMA XL AIR TURNTABLE', 
      image: kuzma6, link: 'https://www.kuzma.si/xl-air-turntable.html' 
      },
    { id: 'kuzma5', name: 'KUZMA XL DC TURNTABLE', 
      image: kuzma5, link: 'https://www.kuzma.si/stabi-xl-dc.html' 
      },
    { id: 'kuzma4', name: 'STABI M TURNTABLE', 
      image: kuzma4, link: 'https://www.kuzma.si/stabi-m.html' 
      },
    { id: 'kuzma3', name: 'STABI REFERENCE 2 TURNTABLE', 
      image: kuzma3, link: 'https://www.kuzma.si/stabi-ref-2.html' 
      },
    { id: 'kuzma2', name: 'STABI R TURNTABLE', 
      image: kuzma2, link: 'https://www.kuzma.si/stabi-r-world-premiere-munchen-2018.html' 
      },
    { id: 'kuzma1', name: 'STABI S TURNTABLE', 
      image: kuzma1, link: 'https://www.kuzma.si/stabi-s.html' 
      },
    ],
    'TONEARMS': [
    { id: 'kuzma7', name: 'STOGI S TONEARM', 
      image: kuzma7, link: 'https://www.kuzma.si/stogi-s.html' 
      },
    { id: 'kuzma8', name: 'STOGI REFERENCE TONEARM', 
      image: kuzma8, link: 'https://www.kuzma.si/stogi-ref.html' 
      },
    { id: 'kuzma9', name: 'STOGI REFERENCE 313 TONEARM', 
      image: kuzma9, link: 'https://www.kuzma.si/stogi-ref-313.html' 
      },
    { id: 'kuzma10', name: '4 POINT 9 TONEARM', 
      image: kuzma10, link: 'https://www.kuzma.si/4point-9.html' 
      },
    { id: 'kuzma11', name: '4 POINT TONEARM', 
      image: kuzma11, link: 'https://www.kuzma.si/4point.html' 
      },
    { id: 'kuzma12', name: '4 POINT 14 TONEARM', 
      image: kuzma12, link: 'https://www.kuzma.si/4point-14-inch.html' 
      },
    { id: 'kuzma13', name: 'SAFIR 9 TONEARM', 
      image: kuzma13, link: 'https://www.kuzma.si/safir-9.html' 
      },
    { id: 'kuzma14', name: 'AIRLINE TONEARM', 
      image: kuzma14, link: 'https://www.kuzma.si/air-line.html' 
      },
    { id: 'kuzma20', name: 'KUZMA SAFIR 12 TONEARM', 
      image: kuzma20, link: 'https://www.kuzma.si/safir-12-soon.html' 
      },  
  ],
  'CARTRIDGES': [
    { id: 'kuzma15', name: 'KUZMA CAR-20', 
      image: kuzma15, link: 'https://www.kuzma.si/cartridges.2' 
      },
    { id: 'kuzma16', name: 'KUZMA CAR-30', 
      image: kuzma16, link: 'https://www.kuzma.si/cartridges.2' 
      },
    { id: 'kuzma17', name: 'KUZMA CAR-40', 
      image: kuzma17, link: 'https://www.kuzma.si/cartridges.2' 
      },
    { id: 'kuzma18', name: 'KUZMA CAR-50', 
      image: kuzma18, link: 'https://www.kuzma.si/cartridges.2' 
      },
    { id: 'kuzma19', name: 'KUZMA CAR-60', 
      image: kuzma19, link: 'https://www.kuzma.si/car-60-soon.html' 
      },
  ],
  },
  
  'WALKER AUDIO': {
    'TURNTABLE': [ 
    { id: 'walkeraudio3', name: 'Walker Audio Proscenium Black Diamond MK5 Turntable', 
      image: walkeraudio3, 
      link: 'Only upgrade available. Please contact us for more information if you wish to upgrade to Master Reference.'
      },
  ],
  },

  'CONSOLIDATED AUDIO BERLIN': {
    'TRANSFORMERS': [ 
    { id: 'consolidated1', name: 'CONSOLIDATED AUDIO MC STEP-UP TRANSFORMER', 
      image: consolidated1, link: 'https://consolidated-audio.de/en/index.php' 
      },
  ],
  },

  'KEITH MONKS': {
    'RECORD CLEANERS': [ //check if this is under any category
    { id: 'keith3', name: 'KEITH MONKS REDUX DISCOVERY ONE', 
        image: keith3, link: 'https://www.keith-monks.com/redux-discoveryone' 
    }, 
    { id: 'keith4', name: 'KEITH MONKS REDUX 2 DISCOVERY ONE', 
      image: keith4, link: 'https://www.keith-monks.com/redux-discoveryone'  //Check the link
  },
    { id: 'keith2', name: 'KEITH MONKS PRODIGY', 
        image: keith2, link: 'https://www.keith-monks.com/prodigy' 
    },
    { id: 'keith1', name: 'KEITH MONKS MICRO LIGHT', 
        image: keith1, link: 'https://www.keith-monks.com/microlight' 
    },
  ],
  },

  'MICHELL AUDIO': {
    'TURNTABLE': [ 
    // { id: 'michell1', name: 'MICHELL ORBE', 
    //   image: michell1, link: 'https://www.michellaudio.com/michell-orbe-turntable' 
    // }, 
    // { id: 'michell2', name: 'MICHELL ORBE SE', 
    //     image: michell2, link: 'https://www.michellaudio.com/michell-orbe-se-turntable' 
    // },
    // { id: 'michell3', name: 'MICHELL GYRODEC', 
    //     image: michell3, link: 'https://www.michellaudio.com/michell-gyrodec-turntable' 
    // },
    // { id: 'michell4', name: 'MICHELL GYRO SE', 
    //     image: michell4, link: 'https://www.michellaudio.com/michell-gyro-se-turntable' 
    // },
    { id: 'michell5', name: 'MICHELL TECNODEC', 
        image: michell5, link: 'https://www.michellaudio.com/michell-tecnodec-turntable' 
    },
    { id: 'michell6', name: 'MICHELL REVOLVE TURNTABLE', 
      image: michell6, link: 'https://www.michellaudio.com/michell-revolv-turntable' 
  },
  { id: 'michell7', name: 'MICHELL GYRO TURNTABLE', 
    image: michell7, link: 'https://www.michellaudio.com/michell-gyro-reference-turntable' 
  },
  ],
  'PHONOSTAGE': [ 
    { id: 'michell8', name: 'APOLLO PHONOSTAGE', 
      image: michell8, link: 'https://www.michellaudio.com/michell-apollo-phonostage' 
    },
  ],
  'TONEARMS': [ 
    { id: 'michell9', name: 'MICHELL T2 TONEARM', 
      image: michell9, link: 'https://www.michellaudio.com/michell-t2-tonearm' 
    },
    { id: 'michell10', name: 'MICHELL T8 TONEARM', 
      image: michell10, link: 'https://www.michellaudio.com/michell-t8-tonearm' 
    },
    { id: 'michell11', name: 'MICHELL TECNOARM 2 TONEARM', 
      image: michell11, link: 'https://www.michellaudio.com/michell-tecnoarm-2-tonearm' 
    },
  ],
  'CARTRIDGES': [ 
    { id: 'michell12', name: 'CUSIS E', 
      image: michell12, link: 'https://www.michellaudio.com/michell-cusis-e-moving-coil-cartridge' 
    },
    { id: 'michell12', name: 'CUSIS E/H', 
      image: michell12, link: 'https://www.michellaudio.com/michell-cusis-e/h-moving-coil-cartridge' 
    },
    { id: 'michell12', name: 'CUSIS S', 
      image: michell12, link: 'https://www.michellaudio.com/michell-cusis-s-moving-coil-cartridge' 
    },
    { id: 'michell13', name: 'CUSIS M', 
      image: michell13, link: 'https://www.michellaudio.com/michell-cusis-m-moving-coil-cartridge' 
    },
  ],
  },

  'SOTA': {
    'STATEMENT SERIES': [ 
    { id: 'sota2', name: 'SOTA MILLENNIA ECLIPSE', 
       image: sota2, link: 'https://sotaturntables.com/products/millennia-eclipse/' 
    },
    { id: 'sota1', name: 'SOTA COSMOS ECLIPSE', 
      image: sota1, link: 'https://sotaturntables.com/products/cosmos-eclipse/' 
    }, 
  ],
  'HERITAGE SERIES': [
    { id: 'sota3', name: 'SOTA SAPHIRE VII', 
        image: sota3, link: 'https://sotaturntables.com/products/sapphire-vii/' 
    }, 
    { id: 'sota4', name: 'SOTA NOVA VII', 
        image: sota4, link: 'https://sotaturntables.com/products/sapphire-vii/' 
    }, 
  ],
  'URBAN SERIES': [
    { id: 'sota5', name: 'SOTA QUASAR', 
        image: sota5, link: 'https://sotaturntables.com/products/quasar/' 
    }, 
    { id: 'sota6', name: 'SOTA COMET VI', 
        image: sota6, link: 'https://sotaturntables.com/products/comet-vi/' 
    }, 
  ],
  },

//   'Dynamic Sounds Associates': {
//      'AMPLIFIERS': [ 
//     { id: 'dsa1', name: 'DSA PHONO III', 
//       image: dsa1, link: 'https://dynamicsounds-assoc.com/content/phono-iii' 
//     }, 
//     { id: 'dsa2', name: 'DSA AMP I', 
//       image: dsa2, link: 'https://dynamicsounds-assoc.com/content/amp-i' 
//     }, 
//     { id: 'dsa3', name: 'DSA PRE I', 
//       image: dsa3, link: 'https://dynamicsounds-assoc.com/content/pre-i' 
//     }, 
//     { id: 'dsa4', name: 'DSA PHONO II', 
//       image: dsa4, link: 'https://dynamicsounds-assoc.com/content/phono-ii' 
//     }, 
//     { id: 'dsa5', name: 'DSA PHONO-ONE', 
//       image: dsa5, link: 'https://dynamicsounds-assoc.com/content/phono-one' 
//     }, 
//   ],
//   },

  'KUDOS AUDIO': {
     'SPEAKERS': [ 
    { id: 'kudos1', name: 'KUDOS TITAN 808 SPEAKERS', 
      image: kudos1, link: 'https://kudosaudio.com/product/titan-808/' 
    }, 
    { id: 'kudos2', name: 'KUDOS TITAN 707 SPEAKERS', 
      image: kudos2, link: 'https://kudosaudio.com/product/titan-707/' 
    }, 
    { id: 'kudos3', name: 'KUDOS TITAN 606 SPEAKERS', 
      image: kudos3, link: 'https://kudosaudio.com/product/titan-606/' 
    }, 
    { id: 'kudos4', name: 'KUDOS TITAN 505 SPEAKERS ', 
      image: kudos4, link: 'https://kudosaudio.com/product/titan-505/' 
    }, 
     ], 
     'ACTIVE DRIVE': [
    { id: 'kudos6', name: 'KUDOS AUDIO SIGAO DRIVE', 
      image: kudos6, link: 'https://kudosaudio.com/product/sigao-drive/' 
    }, ],
    'SPEAKER CABLE': [
        { id: 'kudos5', name: 'KUDOS KS1 SPEAKER CABLE', 
            image: kudos5, link: 'https://kudosaudio.com/product/ks1-loudspeaker-cable/' 
        }, 
    ],
  },

  'CSPORT': {
    'POWER AMPLIFIER': [
   { id: 'csport3', name: 'CSPORT STEREO POWER AMPLIFIER GM70PA', 
     image: csport3, link: 'https://www.csport.audio/products/products-gm70pa-en.html' 
   }, 
   { id: 'csport1', name: 'CSPORT MONAURAL POWER AMPLIFIER 212PAM2', 
    image: csport1, link: 'https://www.csport.audio/products/products-monaural_power_amplifier_212pa-en.html'  
   }, 
  ],
   'PRE-AMPLIFIER': [
   { id: 'csport2', name: 'CSPORT STEREO PRE-AMPLIFIER C3PR', 
     image: csport2, link: 'https://www.csport.audio/products/products-c3pr-en.html' 
   }, 
    ], 
    'PHONO': [ 
    { id: 'csport4', name: 'CSPORT PHONO AMPLIFIER C3EQM2', 
      image: csport4, link: 'https://www.csport.audio/products/products-c3eqm2-en.html'  
    }, ], 
  'TURNTABLE': [ 
    { id: 'csport5', name: 'CSPORT LFT1M2 TURNTABLE', 
      image: csport5, link: 'https://www.csport.audio/products/products-turntable_systemlft1m2-en.html' 
    }, 
    { id: 'csport6', name: 'CSPORT TAT1M2 TURNTABLE', 
      image: csport6, link: 'https://www.csport.audio/products/products-turntabletat1m2-en.html' 
    }, 
    { id: 'csport7', name: 'CSPORT TAT2M2 TURNTABLE', 
      image: csport7, link: 'https://www.csport.audio/products/products-tat2m2-en.html' 
    }, 
   ],
   'TONEARM': [ 
    { id: 'csport8', name: 'CSPORT LINEAR ARM AFU1-2', 
      image: csport8, link: 'https://www.csport.audio/products/products-afu1-2-en.html' 
    }, 
    ],
    'DEMAGNITIZER': [
    { id: 'csport9', name: 'CSPORT STATIC ELIMINATOR AND DEMAG IME1', 
      image: csport9, link: 'https://www.csport.audio/products/products-ime1-en.html' 
    }, 
    ],
    'ACTIVE CROSSOVER': [
    { id: 'csport10', name: 'CSPORT ACTIVE CROSSOVER ACN400', 
      image: csport10, link: 'https://www.csport.audio/products/products-active_crossover_acn400-en.html' 
    }, 
   ],
  },

  'HARTVIG AUDIO': {
     'TURNTABLE': [ 
    { id: 'hartvig1', name: 'HARTVIG EVOLUTION TURNTABLE', 
      image: hartvig1, link: 'http://hartvigaudio.com/products/hartvig-tt-evolution' 
    }, 
    { id: 'hartvig2', name: 'HARTVIG SIGNATURE TURNTABLE', 
      image: hartvig2, link: 'http://hartvigaudio.com/products/signature-tt' 
    }, 
    { id: 'hartvig3', name: 'HARTVIG TURNTABLE', 
      image: hartvig3, link: 'http://hartvigaudio.com/products/hartvig-tt' 
    }, 
  ],
  },

  'TRI-PLANAR': {
     'TONEARM': [ 
    { id: 'triplanar1', name: 'TRIPLANAR ULTIMATE 12 TONEARM', 
      image: triplanar1, link: 'https://www.triplanar.com/u-12/' 
    }, 
    { id: 'triplanar2', name: 'TRIPLANAR U2SE TONEARM', 
      image: triplanar2, link: 'https://www.triplanar.com/u2-se/'
    }, 
    { id: 'triplanar3', name: 'TRIPLANAR MKVII U2 CLASSIC', 
      image: triplanar3, link: 'https://www.triplanar.com/mk-vii/' 
    }, 
  ],
  },

//   'RUSSELL K.': {
//     'LOUDSPEAKERS': [ 
//    { id: 'russellK1', name: 'RUSSELL K. RED 50 LOUDSPEAKERS', 
//      image: russellK1, link: 'https://www.russell-k.com/red-50/' 
//    }, 
//    { id: 'russellK2', name: 'RUSSELL K. RED 100 LOUDSPEAKERS', 
//      image: russellK2, link: 'https://www.russell-k.com/red-100/'
//    }, 
//    { id: 'russellK3', name: 'RUSSELL K. RED 120 LOUDSPEAKERS', 
//      image: russellK3, link: 'https://www.russell-k.com/red-120/' 
//    }, 
//    { id: 'russellK4', name: 'RUSSELL K. RED 120 SE LOUDSPEAKERS', 
//     image: russellK4, link: 'https://www.russell-k.com/red-120se/' 
//   }, 
//   { id: 'russellK5', name: 'RUSSELL K. RED 150 LOUDSPEAKERS', 
//     image: russellK5, link: 'https://www.russell-k.com/red-150/' 
//   }, 
//   { id: 'russellK6', name: 'RUSSELL K. RED 150 SE LOUDSPEAKERS', 
//     image: russellK6, link: 'https://www.russell-k.com/red-150se/' 
//   }, 
//  ],
//  },

 'ATMA SPHERE': {
    'AMPLIFIER': [ 
   { id: 'atmasphere1', name: 'ATMA-SPHERE S-30 TUBE AMPLIFIER', 
     image: atmasphere1, link: 'https://atma-sphere.com/en/s-30.html' 
   }, 
   { id: 'atmasphere2', name: 'ATMA-SPHERE M-60 TUBE AMPLIFIER', 
     image: atmasphere2, link: 'https://atma-sphere.com/en/m-60.html'
   }, 
   { id: 'atmasphere3', name: 'ATMA-SPHERE MA-1 TUBE AMPLIFIER', 
     image: atmasphere3, link: 'https://atma-sphere.com/en/ma-1.html' 
   }, 
   { id: 'atmasphere4', name: 'ATMA-SPHERE MA-2 TUBE AMPLIFIER', 
    image: atmasphere4, link: 'https://atma-sphere.com/en/ma-2.html' 
    }, 
    { id: 'atmasphere5', name: 'ATMA-SPHERE MA-3 TUBE AMPLIFIER', 
        image: atmasphere5, link: 'https://atma-sphere.com/en/ma-3.html' 
    }, 
    { id: 'atmasphere6', name: 'ATMA-SPHERE CLASS D MONOBLOCKS', 
        image: atmasphere6, link: 'https://atma-sphere.com/en/classD.html' 
    }, 
    { id: 'atmasphere7', name: 'ATMA-SPHERE GEM 5 AMPLIFIER', 
        image: atmasphere7, link: 'https://atma-sphere.com/en/gem.html' 
    }, 
    ],
     'PRE-AMPLIFIER': [ 
    { id: 'atmasphere8', name: 'ATMA-SPHERE UV-1 ULTRAVIOLET PRE AMPLIFIER', 
       image: atmasphere8, link: 'https://atma-sphere.com/en/uv-1.html' 
    }, 
    { id: 'atmasphere10', name: 'ATMA-SPHERE MP-1 PRE AMPLIFIER', 
        image: atmasphere10, link: 'https://atma-sphere.com/en/mp-1.html' 
    }, 
    { id: 'atmasphere9', name: 'ATMA-SPHERE MP-3 PRE AMLIFIER', 
       image: atmasphere9, link: 'https://atma-sphere.com/en/mp-3.html' 
    }, 
 ],
 },

 'ZESTO AUDIO': {
    'POWER AMPS': [ 
   { id: 'zestoaudio1', name: 'EROS 500 SELECT, 250 WATTS CLASS A MONOBLOCKS', 
     image: zestoaudio1, link: 'https://www.zestoaudio.com/eros-500-select-power-amp/' 
   }, 
   { id: 'zestoaudio2', name: 'BIA 200 SELECT POWER AMP 200 WATTS STEREO POWER AMP', 
     image: zestoaudio2, link: 'https://www.zestoaudio.com/bia-200-select/'
   }, 
    ],
    'PRE-AMPLIFIER': [
   {
     id: 'zestoaudio3', name: 'LETO ULTRA II PREAMPLIFIER', 
     image: zestoaudio3, link: 'https://www.zestoaudio.com/leto-ultra-ii-preamplifier/'
   },
    ],
   'PHONO AMPLIFIER': [ 
    { 
      id: 'zestoaudio4', name: 'ANDROS TESSERA REFRENCE PHONOSTAGE', 
       image: zestoaudio4, link: 'https://www.zestoaudio.com/andros-tessera-reference-phonostage/' 
    }, 
    { id: 'zestoaudio5', name: 'ANDROS DELUXE II PHONOSTAGE', 
        image: zestoaudio5, link: 'https://www.zestoaudio.com/andros-deluxe-ii-phonostage/' 
    }, 
    { 
      id: 'zustoaudio6', name: 'ANDROS II PHONOSTAGE', 
       image: zestoaudio6, link: 'https://www.zestoaudio.com/andros-ii-phonostage/' 
    }, 
    { 
      id: 'zestoaudio7', name: 'ANDROS SPIRIT PHONOSTAGE', 
       image: zestoaudio7, link: 'https://www.zestoaudio.com/andros-spirit-phonostage/' 
    }, 
     ],
   'DIGITAL ANALOG CONVERTER': [
    {
      id: 'zestoaudio8', name: 'ATHENA DAC', 
     image: zestoaudio8, link: 'https://www.zestoaudio.com/athena-dac/' 
    }
     ],
     'STEP UP TRANSFORMER': [
    {
      id: 'zestoaudio9', name: 'ANDROS ALLASSO STEP UP TRANSFORMER', 
     image: zestoaudio9, link: 'https://www.zestoaudio.com/andros-allasso-step-up-transformer-mc-to-mm-extremely-versatile/' 
    }
     ],
 },
 'UBERLIGHT': {
    '': [ 
   { id: 'uberlight1', name: 'UBERLIGHT FRAME LED DESK AUDIO LIGHTING 7100TL WHITE', 
     image: uberlight1, link: 'https://www.reliablecorporation.com/en-eu/pages/7100tl' 
   }, 
   { id: 'uberlight2', name: 'UBERLIGHT FRAME LED DESK AUDIO LIGHTING 7200TL BLACK', 
     image: uberlight2, link: 'https://www.reliablecorporation.com/en-eu/pages/7200tl'
   }, 
   { id: 'uberlight3', name: 'UBERLIGHT FLEX 3100TL LED TASK LIGHT, USB WITH CLAMP WHITE', 
    image: uberlight3, link: 'https://www.reliablecorporation.com/en-eu/pages/3100tl'
  }, 
  { id: 'uberlight4', name: 'UBERLIGHT FLEX 3100TL LED TASK LIGHT, USB WITH CLAMP BLACK', 
    image: uberlight4, link: 'https://www.reliablecorporation.com/en-eu/pages/3200tl'
  }, 
  { id: 'uberlight5', name: 'UBERLIGHT FLEX 4100 TL LED TASK LIGHT, USB WITH BASE WHITE', 
    image: uberlight5, link: 'https://www.reliablecorporation.com/en-eu/collections/audio-lighting/products/reliable-uberlight-flex-4100tl-led-task-light'
  }, 
  { id: 'uberlight6', name: 'UBERLIGHT FLEX 4100 TL LED TASK LIGHT, USB WITH BASE BLACK', 
    image: uberlight6, link: 'https://www.reliablecorporation.com/en-eu/pages/4200tl'
  }, 
    ],
  },
  'TRENNER & FRIEDL': {
    'SPEAKERS': [ 
   { id: 'trennerFriedl2', name: 'SUN', 
     image: trennerFriedl2, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=sun' 
   }, 
   { id: 'trennerFriedl3', name: 'ART', 
     image: trennerFriedl3, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=art'
   }, 
   { id: 'trennerFriedl4', name: 'PHARAOH', 
    image: trennerFriedl4, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=pharoah'
  }, 
  { id: 'trennerFriedl5', name: 'RA', 
    image: trennerFriedl5, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=ra'
  }, 
  { id: 'trennerFriedl6', name: 'ISIS', 
    image: trennerFriedl6, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=isis'
  }, 
  { id: 'trennerFriedl7', name: 'TALIESIN', 
    image: trennerFriedl7, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=taliesin'
  }, 
  { id: 'trennerFriedl8', name: 'DUKE' ,
    image: trennerFriedl8, link: 'https://www.trenner-friedl.com/index.php?menu=product&sprache=en&second=duke'
  },
  { id: 'trennerFriedl9', name: 'ORINOCO FLOW SPEAKER CABLES', 
    image: trennerFriedl9, link: 'https://www.trenner-friedl.com/index.php?menu=product&second=orinoco&sprache=en'
  },  
    ],
    'WATCH': [ 
      { id: 'trennerFriedl1', name: 'TRENNER & FRIEDL WATCH', 
        image: trennerFriedl1, link: 'https://www.trenner-friedl.com/index.php?menu=product&second=watch1&sprache=en' 
      }, 
    ],
  },
};

// function ProductDetail() {
//     const { brandId } = useParams();
//     const brandData = modelsData[brandId] || {};

//     return (
//         <div className="brand-page">
//           <h1>{brandId}</h1>
//           <div className="categories">
//             {Object.keys(brandData).map((category, index) => (
//               <div key={index} className="category-section">
//                 <h2>{category}</h2>
//                 <div className="models-grid">
//                   {brandData[category].length === 0 ? (
//                     <p>No models available</p>
//                   ) : (
//                     brandData[category].map((model, idx) => (
//                       <div key={idx} className="model-item">
//                         {model.link ? (
//                           <a href={model.link} target="_blank" rel="noopener noreferrer">
//                             <img src={model.image} alt={model.name} className="model-image" />
//                             <p>{model.name}</p>
//                           </a>
//                         ) : (
//                           <Link to={`/products/${brandId}/${model.id}`}>
//                             <img src={model.image} alt={model.name} className="model-image" />
//                             <p>{model.name}</p>
//                           </Link>
//                         )}
//                       </div>
//                     ))
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//     );
// }

function ProductDetail() {
    const { brandId } = useParams();
    const brandData = modelsData[brandId] || {};

    return (
        <div className="brand-page">
            <h1>{brandId}</h1>
            <div className="categories">
                {Object.keys(brandData).length === 0 ? (
                    <p></p>
                ) : (
                    Object.keys(brandData).map((category, index) => (
                        <div key={index} className="category-section">
                            <h2>{category}</h2>
                            <div className="models-grid">
                                {brandData[category].length === 0 ? (
                                    <p>No models available</p>
                                ) : (
                                    brandData[category].map((model, idx) => (
                                        <div key={idx} className="model-item">
                                            {model.link ? (
                                                <a href={model.link} target="_blank" rel="noopener noreferrer">
                                                    <img src={model.image} alt={model.name} className="model-image" />
                                                    <p>{model.name}</p>
                                                </a>
                                            ) : (
                                                <Link to={`/products/${brandId}/${model.id}`}>
                                                    <img src={model.image} alt={model.name} className="model-image" />
                                                    <p>{model.name}</p>
                                                </Link>
                                            )}
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}


export default ProductDetail;
